import React from 'react';
import { Container } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import ViewCounter from '../ViewCounter';
import './style.scss';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <Container className="footer__container">
        <div className="footer__meta">
          <p className="footer__copyright">{t('footer.copyright')}</p>
          <ViewCounter />
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
